import Repository from "../../repository";

export default {
    Current: (payload) => Repository.post(`/api/AquaReports/Current`, payload),
    Total: (payload) => Repository.post(`/api/AquaReports/Total`, payload),
    Detail: (payload) => Repository.post(`/api/AquaReports/Detail`, payload),
}